/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentAccountDto
 */
export interface NovitusPaymentAccountDto {
    /**
     * Nazwa formy płatności na konto bankowe
     * @type {string}
     * @memberof NovitusPaymentAccountDto
     */
    name: string;
    /**
     * Wartość płatności na konto jako string numeryczny
     * @type {string}
     * @memberof NovitusPaymentAccountDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentAccountDto interface.
 */
export function instanceOfNovitusPaymentAccountDto(value: object): value is NovitusPaymentAccountDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentAccountDtoFromJSON(json: any): NovitusPaymentAccountDto {
    return NovitusPaymentAccountDtoFromJSONTyped(json, false);
}

export function NovitusPaymentAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentAccountDtoToJSON(value?: NovitusPaymentAccountDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

